import React from 'react';
import { Paper, Typography, Box, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function HelpScreen({ open, onClose }) {
  if (!open) return null;

  return (
    <Paper
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 4,
        overflow: 'auto'
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          color: 'white'
        }}
      >
        <CloseIcon />
      </IconButton>
      
      <Box sx={{ maxWidth: 600, color: 'white', textAlign: 'left' }}>
        <Typography variant="h4" gutterBottom>
          Welcome to SenseMap
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          How to Use
        </Typography>
        <Typography paragraph>
          • Click on any bubble to view and play its associated highlight
        </Typography>
        <Typography paragraph>
          • Use the search bar to find specific highlights
        </Typography>
        <Typography paragraph>
          • When viewing a highlight, click on tags to filter and explore related highlights
        </Typography>
        <Typography paragraph>
          • Select a theme from the Themes menu to start your exploration with a highlight related to that theme
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          About
        </Typography>
        <Typography paragraph>
          SenseMap visualizes conversations and their connections through an interactive network of highlights.
          Each bubble represents a highlight, and the connections between them show thematic relationships.
        </Typography>

        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            mt: 4,
            backgroundColor: 'transparent',
            color: 'white',
            borderColor: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderColor: 'white',
            },
            fontSize: '1.1rem',
            padding: '10px 24px',
            textTransform: 'none',
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          Let's Explore <span style={{ fontSize: '1.3rem' }}>→</span>
        </Button>
      </Box>
    </Paper>
  );
}

export default HelpScreen; 